import { createI18n } from 'vue-i18n';
import { locale, fallbackLocale } from '@/common/modules/translations';
import { overrideTranslations } from '@/widgets/Wizard/modules/translations';
import translations from '@/widgets/Wizard/i18n/translations';
import overriddenTranslations from '@/widgets/Wizard/i18n/translations.override';
import countries from '@/widgets/Wizard/i18n/countries';
import nationalities from '@/widgets/Wizard/i18n/nationalities';

const messages = overrideTranslations(translations, overriddenTranslations);

export const i18n = createI18n({
    locale,
    fallbackLocale,
    messages: {
        // Dutch
        nl: {
            ...messages.nl,
            ...countries.nl,
            ...nationalities.nl,
        },
        // English
        en: {
            ...messages.en,
            ...countries.en,
            ...nationalities.en,
        },
        // German
        de: {
            ...messages.de,
            ...countries.de,
            ...nationalities.de,
        },
        // French
        fr: {
            ...messages.fr,
            ...countries.fr,
            ...nationalities.fr,
        },
        // Italian
        it: {
            ...messages.it,
            ...countries.it,
            ...nationalities.it,
        },
        // Spanish
        es: {
            ...messages.es,
            ...countries.es,
            ...nationalities.es,
        },
        // Portuguese
        pt: {
            ...messages.pt,
            ...countries.pt,
            ...nationalities.pt,
        },
    },
    legacy: false,
    silentTranslationWarn: true,
    warnHtmlMessage: false,
});

export default i18n;
